<template>
  <div
    v-if="criterion.validate && !!criterion.parentId && criterion.type !== 'SCORE_CONTAINER'"
    class="panel panel-collapsed"
  >
    <div class="panel-hdr">
      <h2>
        {{ criterion.name }}
        <span class="badge ml-2" :class="badgeClass">{{ assessment }}</span>
      </h2>

      <div class="panel-toolbar">
        <button class="btn btn-panel" @click="toggleCollapse">
          <tooltip v-if="collapse" text="Rozwiń">
            <i class="fal fa-angle-double-down" />
          </tooltip>

          <tooltip v-else text="Zwiń">
            <i class="fal fa-angle-double-up" />
          </tooltip>
        </button>
      </div>
    </div>

    <div class="panel-container collapse" :class="{ show: !collapse }">
      <div class="panel-content">
        <p v-if="criterion.description">{{ criterion.description }}</p>

        <div v-if="criterion.type === 'BOOL'" class="mb-2">
          <w-radio class="d-inline-block mr-2" title="Tak" :model="model.passed" :value="1" />

          <w-radio class="d-inline-block mr-2" title="Nie" :model="model.passed" :value="4" />

          <w-radio
            class="d-inline-block mr-2"
            title="Nie dotyczy"
            :model="model.passed"
            :value="2"
          />

          <w-radio class="d-inline-block" title="Do uzupełnienia" :model="model.passed" :value="3" />
        </div>

        <div v-else>
          <w-input type="number" :model="model.value" />
        </div>

        <w-textarea
          v-if="model.passed.$model !== null || criterion.type === 'SCORE'"
          :model="model.description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Tooltip from '@/components/tooltip/Tooltip';

// @vuese
// Pojedynczy element oceny
export default {
  components: {
    ...components,
    Tooltip
  },
  props: {
    // Kryterium oceny
    criterion: {
      type: Object,
      required: true
    },
    // Model oceny
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      collapse: true
    };
  },
  computed: {
    assessment() {
      if (this.criterion.type === 'BOOL') {
        switch (this.model.passed.$value) {
          case '1':
            return 'Tak';
          case '2':
            return 'Nie dotyczy';
          case '3':
            return 'Do uzupełnienia';
          case '4':
            return 'Nie';
          default:
            return '';
        }
      } else {
        return this.model.value.$value;
      }
    },
    badgeClass() {
      if (this.criterion.type === 'BOOL') {
        switch (this.model.passed.$value) {
          case '1':
            return 'badge-success';
          case '2':
            return 'badge-secondary';
          case '3':
            return 'badge-warning';
          case '4':
            return 'badge-danger';
        }
      }
      return 'badge-secondary';
    }
  },
  methods: {
    // @vuese
    // Rozwija panel kryterium
    toggleCollapse() {
      this.collapse = !this.collapse;
    }
  }
};
</script>

<style>
.page-content .panel {
  margin-bottom: 0.2rem;
}
</style>
